import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';

export default function useWasParms() {
  const { passedAppFunctions } = useContext(AppContext);

  return passedAppFunctions.wasParms;
}
